//@ts-nocheck
import {
    Connection,
    ParsedInstruction
} from "@solana/web3.js";
import { from } from "rxjs";
import { mergeMap, toArray, map } from "rxjs/operators";
import { toPublicKey } from "./to-publickey";

let count = 0;
async function getMints(candy_id: string,
    connection: Connection,
    setCounter: any
) {
    candy_id = process.env.REACT_APP_CANDY_MACHINE_ID;
    console.log(candy_id, 'cid');
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
        const all_signatures = [];
        const options = { before: undefined, limit: 1000 };
        let retries = 0;
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // console.log(await connection.getSignaturesForAddress(
            //     toPublicKey(candy_id),
            //     options
            // ), 'sign');
            let signatures = await connection.getSignaturesForAddress(
                toPublicKey(candy_id),
                options
            );
            signatures=signatures.filter(a=>!a.err)
            if (signatures.length == 0) {
                // GBT errors can cause empty returns, we try a few times
                if (retries < 10) {
                    retries++;
                } else {
                    break;
                }
            } else {
                options.before = signatures[signatures.length - 1].signature;
                all_signatures.push(...signatures);
                retries = 0;
            }
        }
        // Slice into chunks to avoid hitting size limit;
        const chunks = sliceIntoChunks(all_signatures, 150);

        from(chunks)
            .pipe(
                mergeMap(async (chunk) => {
                    let retries = 0;
                    let parsedTxs = await connection.getParsedTransactions(
                        chunk.map((tx) => tx.signature)
                    );
                    // console.log(parsedTxs, 'ptxs')
                    parsedTxs = parsedTxs.filter(a => a)

                    // console.log(parsedTxs, 'parsedTxs')
                    while (retries < 5) {
                        if (!parsedTxs?.every((tx) => !!tx)) {
                            retries++;
                            return [];
                        } else {
                            return parsedTxs.filter((tx) => !!tx);
                        }
                    }
                }, 4),
                map((chunk) => {
                    // console.log(chunk, 'chunk')
                    return chunk
                        .map((h) => {
                            const mint = (
                                h?.transaction?.message?.instructions as ParsedInstruction[]
                            )?.find((ix) => ix?.parsed?.type === "mintTo")?.parsed?.info
                                ?.mint;
                            
                            // console.log(mint, 'mint')
                            

                            const botTax = h?.meta?.logMessages?.find(log =>
                                log.includes('Candy Machine Botting is taxed at')
                            );

                            if (!h?.meta?.err && mint && !botTax) {
                                setCounter(count++);
                                console.log(mint, 'returning mint')
                                return mint;
                            }
                        })
                        .filter((r) => !!r);
                }),
                toArray()
            )
            .subscribe((res) => {
                resolve(res.flat());
                count = 0;
            });
    });
}

export function sliceIntoChunks(arr: any[], chunkSize: number) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}


export default getMints